import React from 'react';
import { Label} from 'semantic-ui-react'

import Config from '../../Config'
import Helper from '../Sistema/Helper'

class IsDevIndicator extends React.Component{

    render() {

        

        const conteudo = (this.props.exibeAmbiente=== false) ?  `${this.props.content || ''} ` :   ` ${Config.AMBIENTE} | ${this.props.content || ''} ` 
        
        return <span>
            {Helper.isDevEnvironment() &&
                <Label color='red' 
                    icon='code'
                    content={conteudo} 
                    ribbon={this.props.ribbon || this.props.ribbon === true}
                    tag={this.props.tag || this.props.tag === true}
                    corner={this.props.corner}
                    horizontal={this.props.horizontal || this.props.horizontal === true}
                    floating={this.props.floating || this.props.floating === true}
                    size={this.props.size}
                    >
                </Label>
          }
        </span>
    }
}

export default IsDevIndicator;


// WEBPACK FOOTER //
// ./src/components/Ambiente/IsDevIndicator.js